"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconModule = _interopRequireDefault(require("../icon/icon.module.scss"));

var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,

  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool
};
var defaultProps = {
  title: null,
  box: false,
  sizeClass: 'regular'
};

var CrossRegularIcon = function CrossRegularIcon(_ref) {
  var title = _ref.title,
      box = _ref.box,
      sizeClass = _ref.sizeClass,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title", "box", "sizeClass"]);

  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "currentcolor",
    "aria-labelledby": title ? 'CrossRegularIconTitle' : undefined,
    "aria-hidden": title ? 'false' : 'true',
    role: "img"
  }), title && /*#__PURE__*/_react["default"].createElement("title", {
    id: "CrossRegularIconTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 11.2631579L18.2631579 5 19 5.73684211 12.7368421 12 19 18.2631579 18.2631579 19 12 12.7368421 5.73684211 19 5 18.2631579 11.2631579 12 5 5.73684211 5.73684211 5z"
  }));

  if (box) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _iconModule["default"].box
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _iconModule["default"][sizeClass]
    }, svg));
  }

  ;
  return svg;
};

CrossRegularIcon.displayName = 'CrossRegularIcon';
CrossRegularIcon.propTypes = propTypes;
CrossRegularIcon.defaultProps = defaultProps;
var _default = CrossRegularIcon;
exports["default"] = _default;